import React from "react";
import { Link } from "react-router-dom";
import { useLivestreamContext } from "ui/context/LivestreamContext";
import { Button, StreamStatus } from "ui/components";
import { Channel, getFileURL } from "core/models";
import { cx } from "utils/join-classnames";
import styles from "./ChannelCard.module.scss";

interface Props {
    channel: Channel;
    allowLivestreamPlayer: boolean;
}

const Channelcard: React.FC<Props> = ({ channel, allowLivestreamPlayer }) => {
    const { addChannel } = useLivestreamContext();
    const openStream = (event: React.MouseEvent) => {
        event.preventDefault();
        if (channel.exStream.online === false) {
            return;
        }
        addChannel(channel);
    };

    return (
        <Link
            className={styles.channel}
            to={`/editor/${channel.key}/${channel.id}`}
        >
            <div
                className={cx(
                    styles.channel__thumbnail,
                    !channel.exStream.online
                        ? styles.channel__thumbnail__offline
                        : null,
                )}
                style={{
                    backgroundImage: `url(${getFileURL(
                        channel.id,
                        channel.exStream.thumbnailPath,
                        channel.exStream.token,
                    )})`,
                }}
            >
                {!channel.exStream.online && (
                    <div className={styles.channel__thumbnail__placeholder}>
                        view old content
                    </div>
                )}
                <StreamStatus
                    online={channel.exStream.online}
                    className={styles.channel__status}
                />
            </div>
            <div className={styles.channel__info}>
                <div className={styles.channel__title}>{channel.name}</div>
                <div className={styles.spacer} />
                {allowLivestreamPlayer && (
                    <>
                        {channel.exStream.online ? (
                            <div
                                className={styles.openchannel}
                                onClick={openStream}
                                role="presentation"
                            >
                                <Button
                                    type="function"
                                    theme="light"
                                    tooltip="Watch channel live"
                                    icon="preview"
                                />
                            </div>
                        ) : (
                            <div className={styles.openchannel}>
                                <Button
                                    type="function"
                                    theme="light"
                                    tooltip="Stream is offline"
                                    icon="preview"
                                    disabled
                                />
                            </div>
                        )}
                    </>
                )}
            </div>
        </Link>
    );
};

export default Channelcard;
